/* istanbul ignore file */
export { default } from './Layout';
